import { ParentState } from "@hopper-b2b/checkout";
import type { State } from "xstate";
import {
  type PartialParentContextWithTermsAndConditions,
  termsAndConditionsStep,
} from "./context";

export const getTermsAndConditionsAccepted = (
  state: State<PartialParentContextWithTermsAndConditions>
) => state.context[ParentState.review][termsAndConditionsStep]?.accepted;
